import amplifyConfig from '../config';
import API_PATH from './endpoints';
import axiosInstance from '../utils/axios';
import type { AxiosResponse } from 'axios';
import type { UserWithOrganizationType } from '../types/user';
import type { UpdateNotificationParams, UpdateNotificationResponse } from '../types/ownInfo';

const ownInfoAPI = {
  /**
   * ユーザ情報の取得
   * @return UserWithOrganizationType
   */
  getOwnInfo: async () => {
    return axiosInstance.get<undefined, AxiosResponse<UserWithOrganizationType>>(amplifyConfig.apiGateway.URL + API_PATH.OWNINFO.OWNINFO);
  },

  /**
   * メール通知の更新
   * @param UpdateNotificationParams
   * @return UpdateOrganizationUserResponse
   */
  updateNotification: async (params: UpdateNotificationParams) => {
    const { id, emailNotificationFlag, emailNotificationCustomers } = params;
    return axiosInstance.put<UpdateNotificationParams, AxiosResponse<UpdateNotificationResponse>>(amplifyConfig.apiGateway.URL + API_PATH.OWNINFO.ORGANIZATION_USER + '/' + id, {
      emailNotificationFlag,
      emailNotificationCustomers,
    });
  },
};

export default ownInfoAPI;
